import { useMutation } from '@tanstack/react-query'

import { updateUserCarousels } from './api'

export const useUpdateUserCarouselsMutation = () =>
  useMutation({ mutationFn: updateUserCarousels })
